export default {
  path: '/job',
  name: 'job',
  redirect: { name: 'home' },
  component: () => import(/* webpackChunkName: "job" */ '@/views/job'),
  children: [
    {
      path: '/post-a-tool',
      name: 'job.create-job-page',
      meta: {
        requiresAuth: true,
        requiresVerified: true,
        requiresVerifiedId: true,
        requiresPayout: true
      },
      component: () =>
        import(
          /* webpackChunkName: "create-job-page" */ '@/views/job/CreateJobPage.vue'
        )
    },
    {
      path: '/my-tools',
      name: 'job.my-jobs-page',
      meta: {
        requiresAuth: true,
        requiresVerified: true,
        requiresVerifiedId: true,
        requiresPayout: true
      },
      component: () =>
        import(
          /* webpackChunkName: "my-jobs-page" */ '@/views/job/MyJobsPage.vue'
        )
    },
    {
      path: '/tools/:id/:title',
      name: 'job.view-job-page',
      meta: { mayRequireAuth: true },
      component: () =>
        import(
          /* webpackChunkName: "view-job-page" */ '@/views/job/ViewJobPage.vue'
        )
    },
    {
      path: '/tools/:id/:title/edit',
      name: 'job.edit-job-page',
      meta: {
        requiresAuth: true,
        requiresVerified: true,
        requiresVerifiedId: true,
        requiresPayout: true
      },
      component: () =>
        import(
          /* webpackChunkName: "edit-job-page" */ '@/views/job/EditJobPage.vue'
        )
    },
    {
      path: '/tools/:id/:title/rent',
      name: 'job.rent-job-page',
      meta: {
        requiresAuth: true,
        requiresVerified: true,
        requiresVerifiedId: true
      },
      component: () =>
        import(
          /* webpackChunkName: "rent-job-page" */ '@/views/job/RentJobPage.vue'
        )
    }
  ]
}
